/** Форматирование чисел и дат для экрана результата (§10, §16.5). */

const MONEY = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 })

export function formatMoney(value: string | number): string {
  const num = typeof value === 'string' ? Number(value) : value
  if (!Number.isFinite(num)) return String(value)
  return `${MONEY.format(num)} ₽`
}

export function formatPercent(value: string | number): string {
  return `${value}%`
}

export function formatDate(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleDateString('ru-RU')
}

export function formatDateTime(iso: string | null | undefined): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}
